import type { InsuranceProviderSettingsGeneral } from '@/general/src/insuranceProvider/shared.js'
import { getConstKeys } from '@/general/src/other/getConstKeys.js'
import { z } from 'zod'

export const zRenesSettings = z.object({
  login: z.string(),
  password: z.string(),
  chainNumber: z.string(),
  codeReciever: z.string(),
})
export type RenesSettings = z.infer<typeof zRenesSettings>
export const renesSettingsInitialValues: RenesSettings = {
  login: '',
  password: '',
  chainNumber: '',
  codeReciever: '',
}
export const renesSettingsKeysMap = {
  login: 'Логин',
  password: 'Пароль',
  chainNumber: 'Номер цепочки продаж',
  codeReciever: 'Телефон или почта для подтверждения входа',
}
export const renesSettingsKeys = getConstKeys(renesSettingsKeysMap)
export const renesSettingsGeneral = {
  insuranceProvider: 'renes',
  zSchema: zRenesSettings,
  initialValues: renesSettingsInitialValues,
  keysMap: renesSettingsKeysMap,
  keys: renesSettingsKeys,
} satisfies InsuranceProviderSettingsGeneral
